import React from 'react';

const SideBetsPlayerCards = ({
  players = [],
  imageMap,
  fallbackImage,
  loading,
  error,
  formatCurrency,
}) => {
  if (error) {
    return <p className="chart-error">Unable to load the side bet player breakdown right now.</p>;
  }

  if (loading) {
    return <p className="chart-loading">Loading player cards…</p>;
  }

  if (!players.length) {
    return <p className="chart-empty">No player totals available yet.</p>;
  }

  return (
    <div className="player-cards-container">
      {players.map((player) => {
        const imgSrc = (imageMap && imageMap[player.name]) || fallbackImage;
        const toneClass =
          player.total > 0 ? 'highlight-green' : player.total < 0 ? 'highlight-red' : '';
        const valueClass = ['player-card-value', toneClass].filter(Boolean).join(' ');

        return (
          <article key={player.name} className="stats-card player-card">
            <div
              className="player-card-avatar"
              style={{
                width: 84,
                height: 84,
                borderRadius: '50%',
                overflow: 'hidden',
                margin: '0 auto 8px',
                boxShadow: '0 0 0 4px #fff, 0 2px 6px rgba(0,0,0,.12)'
              }}
            >
              <img
                src={imgSrc}
                alt={player.name}
                style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' , marginTop: '8px'}}
              />
            </div>
            <h3 className="player-card-name">{player.name}</h3>
            <p className={valueClass}>
              {formatCurrency ? formatCurrency(player.total) : player.total}
            </p>
          </article>
        );
      })}
    </div>
  );
};

export default SideBetsPlayerCards;
